import { DatePicker } from 'antd';
import './Calendar.css';

export default function Calendar({ onChange, picker, value, disabledDate, disabled }) {
    // componentDidMount() {
    //     var cpicker = document.getElementsByClassName('ant-picker-input')
    //     if (cpicker !== null && cpicker !== undefined) {
    //         if (cpicker.length !== undefined) {
    //             for (var i = 0; i < cpicker.length; i++) {
    //                 if (cpicker[i] !== null && cpicker[i] !== undefined) {
    //                     cpicker[i].firstElementChild.disabled = true
    //                 }
    //             }
    //         }
    //     }
    // }

    return (
        <DatePicker
            allowClear={false}
            className={"form-control"}
            onChange={onChange}
            picker={picker}
            style={{
                fontFamily: "poppins",
                fontSize: "0.75rem",
                Color: "black",
                lineHeight: "1.5",
                cursor: "pointer",
            }}
            value={value}
            disabledDate={disabledDate}
            disabled={disabled}
        />
    )
}
